/* =========================================================
   TELEPASS GRAB&GO THEME — Theme JS
   Header scroll, accordion, side menu, form handling
   ========================================================= */

// === HEADER SCROLL BEHAVIOR ===
(function() {
  var header = document.querySelector('.header');
  if (!header) return;

  window.addEventListener('scroll', function() {
    if (window.scrollY > 50) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
  }, { passive: true });
})();

// === SIDE MENU (MOBILE) ===
function toggleSideMenu(open) {
  var drawer = document.getElementById('side-menu-drawer');
  var overlay = document.getElementById('side-menu-overlay');
  if (!drawer || !overlay) return;

  if (open) {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  } else {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
}

function handleHamburgerClick() {
  var drawer = document.getElementById('side-menu-drawer');
  var isOpen = drawer && drawer.classList.contains('is-open');
  toggleSideMenu(!isOpen);
}

// === PRODUCT ACCORDION ===
function toggleAccordion(button) {
  var content = button.nextElementSibling;
  var icon = button.querySelector('.material-symbols-outlined');
  var item = button.closest('.accordion-item');
  if (!content || !item) return;

  // Close all siblings
  var siblings = item.parentElement.querySelectorAll('.accordion-item');
  siblings.forEach(function(sibling) {
    if (sibling !== item && sibling.classList.contains('is-open')) {
      sibling.classList.remove('is-open');
      var sibContent = sibling.querySelector('.accordion-item__content');
      var sibIcon = sibling.querySelector('.accordion-item__icon');
      if (sibContent) { sibContent.style.maxHeight = '0px'; sibContent.style.opacity = '0'; }
      if (sibIcon) sibIcon.style.transform = 'rotate(0deg)';
    }
  });

  // Toggle current
  if (item.classList.contains('is-open')) {
    item.classList.remove('is-open');
    content.style.maxHeight = '0px';
    content.style.opacity = '0';
    if (icon) icon.style.transform = 'rotate(0deg)';
  } else {
    item.classList.add('is-open');
    content.style.maxHeight = content.scrollHeight + 'px';
    content.style.opacity = '1';
    if (icon) icon.style.transform = 'rotate(180deg)';
  }
}

// === FAQ ACCORDION (details/summary auto-close) ===
document.addEventListener('DOMContentLoaded', function() {
  var faqItems = document.querySelectorAll('.faq-item');
  faqItems.forEach(function(targetDetail) {
    targetDetail.addEventListener('click', function() {
      faqItems.forEach(function(detail) {
        if (detail !== targetDetail) {
          detail.removeAttribute('open');
        }
      });
    });
  });
});

// === CONTACT FORM HANDLING ===
document.addEventListener('DOMContentLoaded', function() {
  var form = document.getElementById('contactForm');
  if (!form) return;

  form.addEventListener('submit', function(e) {
    // Allow Shopify's native form processing
    var btn = form.querySelector('button[type="submit"]');
    if (!btn) return;

    var originalContent = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = '<span class="material-symbols-outlined" style="animation: spin 1s linear infinite;">sync</span> <span>INVIO IN CORSO...</span>';

    // Re-enable after a delay if form doesn't navigate
    setTimeout(function() {
      btn.disabled = false;
      btn.innerHTML = originalContent;
    }, 5000);
  });
});

// === SEARCH INPUT MICRO-INTERACTION ===
document.addEventListener('DOMContentLoaded', function() {
  var searchInput = document.querySelector('.support-hero__search input');
  if (!searchInput) return;

  searchInput.addEventListener('focus', function() {
    searchInput.parentElement.style.transform = 'scale(1.02)';
    searchInput.parentElement.style.transition = 'transform 0.2s ease';
  });
  searchInput.addEventListener('blur', function() {
    searchInput.parentElement.style.transform = 'scale(1)';
  });
});

// === PRODUCT IMAGE GALLERY ===
document.addEventListener('DOMContentLoaded', function() {
  var thumbs = document.querySelectorAll('.product-gallery__thumb');
  var mainImg = document.getElementById('product-main-img');
  if (!mainImg || thumbs.length === 0) return;

  thumbs.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      // Remove active from all
      thumbs.forEach(function(t) { t.classList.remove('is-active'); });
      // Add active to clicked
      thumb.classList.add('is-active');
      // Update main image
      var img = thumb.querySelector('img');
      if (img) {
        mainImg.src = img.src.replace(/width=\d+/, 'width=900');
        mainImg.alt = img.alt;
      }
    });
  });
});

// === SPIN ANIMATION KEYFRAME (injected for form button) ===
(function() {
  var style = document.createElement('style');
  style.textContent = '@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }';
  document.head.appendChild(style);
})();

// === EMBEDDED VIDEO INITIAL FRAME (0.01s) ===
document.addEventListener('DOMContentLoaded', function() {
  var videos = document.querySelectorAll('video');
  videos.forEach(function(video) {
    if (video.autoplay) return;
    function setInitialFrame() {
      if (video.currentTime === 0 && !video.hasAttribute('data-frame-adjusted')) {
        try {
          video.currentTime = 0.01;
          video.setAttribute('data-frame-adjusted', 'true');
        } catch (e) {}
      }
    }
    if (video.readyState >= 1) {
      setInitialFrame();
    } else {
      video.addEventListener('loadedmetadata', setInitialFrame);
      video.addEventListener('loadeddata', setInitialFrame);
      video.addEventListener('canplay', setInitialFrame);
    }
  });
});
